import { render } from "./UploadPreflight.vue?vue&type=template&id=20630d52"
import script from "./UploadPreflight.vue?vue&type=script&lang=js"
export * from "./UploadPreflight.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__